import React from "react";
import { useState } from "react";
import "./order-details.css";
import ProgressTrackerreturn from "../Progresstracker/ProgressTrackerreturn";
import OrderSummary from "./OrderSummary";
import Confirmcancelorder from "./Confirmcancelorder";
function Trackreturn() {

  const [showpopup,setShowpopup] = useState(false);

  const Cancelordershowpopup = ()=>{
    setShowpopup(true);
  }

  const Cancelorderclosepopup = ()=>{
    setShowpopup(false);
  }

  return (
    <section className="tracking_order_section pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-10">
            <div className="inner_box_one">
              <h5>
                Your Order will be Delivered on <b>12th Oct 2024</b>
              </h5>
              <button className="btn_1_1" onClick={Cancelordershowpopup}>Cancel order</button>
            </div>
            <div className="reason_content">
              <div className="inner-box ">
                <p className="mb-0">
                  {" "}
                  <b>Reason :</b> Package was damaged
                </p>
                <span>Delivered on 9-10-2024 </span>
              </div>
            </div>
            <div className="progressbartracking_two">
              <ProgressTrackerreturn currentstep={1} />
            </div>
            <div className="order_summary">
              <div className="row">
                <div className="col-lg-5 left_col">
                  <div className="sub_box">
                    <div className="order_id">
                      <h6>Return ID</h6>
                      <p>AAMMII-22554KLH-26597465</p>
                    </div>
                    <div className="shipping_address">
                      <h6>Pickup Address</h6>
                      <p>
                        Raghuraj S No.3, Venkatanarayana Road, Trustpuram,
                        Choolaimedu, Coimbatore - 641 056.
                      </p>
                    </div>
                    <div className="payment_method">
                      <h6>Refund Method</h6>
                      <p className="mb-0">
                        Visa &nbsp;<span>****</span>&nbsp;<span>****</span>
                        &nbsp;
                        <span>****</span>&nbsp;<span>6508</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 right_col">
                  <div className="sub_box">
                    <div className="order_id">
                      <h6>Order summery </h6>
                    </div>
                    <div>
                      <table>
                        <tr>
                          <td>Groundnut Oil, 1ltr (2) </td>
                          <td>₹720</td>
                        </tr>
                        <tr>
                          <td>Coconut Oil, 1ltr (1) </td>
                          <td>₹390</td>
                        </tr>

                        <tr>
                          <td>
                            <h6>Total</h6>
                          </td>
                          <td>
                            <h6>₹1100</h6>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     {showpopup ? <Confirmcancelorder Close={Cancelorderclosepopup} /> : null} 
    </section>
  );
}

export default Trackreturn;
